<template>
    <div class="author-info" style="display: inline-flex">
      <img :src="authorImage" :alt="authorName" class="author-image" loading="eager">
      <div class="author-details" style="margin: 5px;">
        <h3 style="color: #ffffffe5;">{{ authorName }}</h3>
        <p style="font-size: 13px;color: #ffffffe5;">{{ authorDescription }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AuthorInfo',
    props: {
      authorName: String,
      authorImage: String,
      authorDescription: String
    }
  }
  </script>